// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".author.svelte-17tvy0h.svelte-17tvy0h{margin:0 0 -16px;font-size:16px}.author.svelte-17tvy0h span.svelte-17tvy0h{font-size:14px;font-weight:500}.message-box.svelte-17tvy0h.svelte-17tvy0h{position:relative;margin:0 0 -8px;width:100%;max-width:350px}.button.svelte-17tvy0h.svelte-17tvy0h{background:var(--interaction-cta);color:var(--nav-active-foreground);font-weight:600;padding:4px 10px;border-radius:26px;text-decoration:none;font-size:16px;max-width:255px;width:100%}", ""]);
// Exports
module.exports = exports;
